import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TransitAutocompleteHeader } from '../../TransitAutocompleteHeader';
import { TransitInputHeader } from '../../TransitInputHeader';
import { TransitViewHouseFormValues } from '../../validateTransitViewHouseForm';
import { TransitViewEditHouseFormValues } from './validateTransitViewEditHouseForm';

interface HouseConsignorProps {
  form: UseFormReturnType<TransitViewHouseFormValues>;
  houseForm: UseFormReturnType<TransitViewEditHouseFormValues>;
  editDisabled: boolean;
}

export const HouseConsignor: React.FC<HouseConsignorProps> = ({ form, houseForm, editDisabled }) => {
  const consignorParent = form?.values?.Consignment?.Consignor;
  const isConsignorDefined = consignorParent && (consignorParent.name || consignorParent?.identificationNumber);

  return (
    <Stack mb="md">
      <Title order={5} fw={600}>
        Consignor
      </Title>

      <Grid>
        <Grid.Col span={6}>
          <TransitInputHeader
            form={houseForm}
            name="Consignor.identificationNumber"
            label="Identification Number"
            parents={isConsignorDefined ? [consignorParent.identificationNumber] : []}
            disabled={editDisabled || !!isConsignorDefined}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <TransitInputHeader
            form={houseForm}
            name="Consignor.name"
            label="Name"
            parents={isConsignorDefined ? [consignorParent.name] : []}
            disabled={editDisabled || !!isConsignorDefined}
          />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={3}>
          <TransitInputHeader
            form={houseForm}
            name="Consignor.Address.streetAndNumber"
            label="Street and Number"
            parents={isConsignorDefined ? [consignorParent.Address?.streetAndNumber] : []}
            disabled={editDisabled || !!isConsignorDefined}
          />
        </Grid.Col>
        <Grid.Col span={3}>
          <TransitInputHeader
            form={houseForm}
            name="Consignor.Address.postcode"
            label="Postcode"
            parents={isConsignorDefined ? [consignorParent.Address?.postcode] : []}
            disabled={editDisabled || !!isConsignorDefined}
          />
        </Grid.Col>
        <Grid.Col span={3}>
          <TransitInputHeader
            form={houseForm}
            name="Consignor.Address.city"
            label="City"
            parents={isConsignorDefined ? [consignorParent.Address?.city] : []}
            disabled={editDisabled || !!isConsignorDefined}
          />
        </Grid.Col>
        <Grid.Col span={3}>
          <TransitAutocompleteHeader
            form={houseForm}
            parents={isConsignorDefined ? [consignorParent.Address?.country] : []}
            name="Consignor.Address.country"
            disabled={editDisabled || !!isConsignorDefined}
            placeholder="Country"
            code="CL008"
          />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
